import Vue from 'vue'
import { Decimal } from 'decimal.js'

Vue.mixin({
  methods: {
    add(x, y) {
      return new Decimal(x).plus(new Decimal(y)).toNumber()
    },
    sub(x, y) {
      return new Decimal(x).minus(new Decimal(y)).toNumber()
    },
    mul(x, y) {
      return new Decimal(x).mul(new Decimal(y)).toNumber()
    },
    div(x, y) {
      return new Decimal(x).div(new Decimal(y)).toNumber()
    }
  }
})